import { gql } from "@apollo/client";

export const GET_USER_DETAILS = gql`

query Org_users_by_pk ($id: uuid!) {
    org_users_by_pk(id: $id) {
first_name
        last_name
        email
        gender
        phone
        dob
        profile_picture_id
        profile_pic_url
        id
        addresses(where: {  deleted_at: { _is_null: true } }) {
            address1
            address2
            address_type
            country_id
            created_at
            deleted_at
            id
            is_active
     country {
                name
          
            }
            is_primary
            landmark
            phone
            whatsapp_number
            pincode
            receiver_first_name
            receiver_last_name
            state_id
            user_id
        }
    }
}
    


`;
export const GET_CART_FOR_STOCK_FREEZE = gql`
 query getCartForStockFreeze($cart_id: uuid!) {
    order_carts(where: { id: { _eq: $cart_id } }) {
        id
        cart_items(where: { is_deleted: { _eq: false } }) {
            id
            product_id
            quantity
            product_variation_id
            frozen_quantity
            __typename
            cart_item_sizes(where: { is_deleted: { _eq: false } }) {
                id
                variant_size_id
                quantity
                metal
                frozen_quantity
                plating_id
                __typename
                product_variant_size {
                    id
                    quantity
                    ring_size
                    ring_inr_size
                    stone_code
                    weight
                    __typename
                }
            }
            product_product {
                id
                name
                available_quantity
                __typename
            }
            product_variation {
                id
                value
                __typename
            }
        }
    }
}
`;
export const GET_EXISTING_ORDER_CART = gql`
  query ordercart($where: order_carts_bool_exp = {}) {
    order_carts(where: $where) {
      id
      cart_items(
        where: {
          _and: [
            { deleted_at: { _is_null: true } }
            { is_deleted: { _eq: false } }
          ]
        }
      ) {
        id
        product_id
        quantity
        product_variation_id
        cart_id
        type
        is_deleted
        final_amount
        created_at
        __typename
        frozen_quantity
        cart_item_sizes {
          id
          variant_size_id
          quantity
          is_deleted
          metal
          frozen_quantity
          plating_id
          __typename
        }
        product {
          name
          product_variations {
            actual_price
            id
            name
            quantity
            sale_price
            product_media {
              media {
                bucket
                cloud
                id
                visibility
                path
              }
            }
          }
        }
      }
      __typename
      cart_item_sizes {
        product_variant_size {
          quantity
          original_stock
        }
      }
    }
  }
`;


export const PRODUCTS_DISPLAY = gql`
  query Product_products(
    $where: product_products_bool_exp
    $order_by: [product_products_order_by!]
    $limit: Int
    $offset: Int
  ) {
    product_products(
      where: $where
      order_by: $order_by
      limit: $limit
      offset: $offset
    ) {
      id
      name
      price
      price_per_gm
      priority
      category_id
      sub_category_id
      product_code
      item_code
      has_variation
      __typename
      dim_weight
      category {
        name
        __typename
      }

      sub_category {
        id
        name
        __typename
      }

      product_media(limit: 1) {
        media {
          path
          __typename
        }
        __typename
      }

      variations_total: product_variations_aggregate {
        aggregate {
          count
        }
      }

      product_variations {
        id
        name
        price
        value
        product_variation_gems {
          gems_id
          gem {
            id
            name
          }
        }
        # Stock is summed client-side from these rows (computeTotalStock /
        # variationStock fall back to them), so the separate
        # product_variant_sizes_aggregate was a duplicate lookup and is removed.
        product_variant_sizes {
          id
          pro_code
          quantity
          __typename
        }
        __typename
        product_media(limit: 1) {
          media {
            path
            __typename
          }
          __typename
        }
      }
    }

    product_products_aggregate(where: $where) {
      aggregate {
        count(columns: [id])
      }
    }
  }
`;
export const PRODUCTS_DISPLAY_BIRTHSTONE = gql`
  query Product_products(
    $where: product_products_bool_exp
    $order_by: [product_products_order_by!]
    $limit: Int
    $offset: Int
  ) {
    product_products(
      where: $where
      order_by: $order_by
      limit: $limit
      offset: $offset
    ) {
      id
      name
      price
      price_per_gm
      priority
      category_id
      sub_category_id
      product_code
      item_code
      has_variation
      __typename
      dim_weight
      category {
        name
        __typename
      }

      sub_category {
        id
        name
        __typename
      }

      product_media(limit: 1) {
        media {
          path
          __typename
        }
        __typename
      }

      variations_total: product_variations_aggregate {
        aggregate {
          count
        }
      }

 product_variations {
  id
  name
  value
  price
  product_variant_sizes{
    pro_code
    stone_code
  }
    product_variation_gems {
    gems_id
    gem {
      id
      name
    }
  }
  product_variant_sizes_aggregate {  
    aggregate {
      sum {
        quantity
      }
    }
  }
        __typename
        product_media(limit: 1) {
          media {
            path
            __typename
          }
          __typename
        }
      }
    }

    product_products_aggregate(where: $where) {
      aggregate {
        count(columns: [id])
      }
    }
  }
`;
// ✅ Separate lightweight query just for the size filter sidebar.
// Uses cache-first so it only hits the network once per filter context change.
export const GET_VARIANT_SIZES_FOR_FILTER = gql`
  query GetVariantSizesForFilter($where: product_products_bool_exp) {
    product_products(where: $where) {
      id
      product_variations {
        product_variant_sizes {
          ring_size
          ring_inr_size
          size_value
          quantity
        }
      }
    }
  }
`;

export const INSERT_CART = gql`
mutation cartInsert($object: order_carts_insert_input = {}) {
  insert_order_carts_one(object: $object) {
    id
    status
    user_id
  }
}

`
export const MODIFY_CART_ITEMS = gql`
mutation modifycart($objects: [order_cart_items_insert_input!] = {}) {
  insert_order_cart_items(objects: $objects, on_conflict: {constraint: cart_items_cart_id_product_id_product_variation_id_key, update_columns: [quantity,deleted_at,is_deleted]}) {
    returning {
      id
    }
  }
}

`
export const GET_WISHLIST_DATA = gql`
query Order_wishlist {
    order_wishlist {
        deleted_at
        deleted_by_id
        id
        product_id
        product_variation_id
        user_id
        product {
            name
            moq
            product_variations {
                actual_price
                id
                name
                product_id
                quantity
                sale_price
                status
                product_media {
                    product_id
                    product_variation_id
                    media {
                                    path
                    bucket
                    visibility
                    cloud
                    }
                }
            }
        }
    }
}


    
`;

export const GET_ORDER_CART_ITEMS_DATA = gql`
query Order_carts($where: order_carts_bool_exp, $order_by: [order_carts_order_by!]) {
  order_carts(where: $where, order_by: $order_by) {
    status
    id
    order_number
    insurance_charge
    final_amount
    processed_at
    subtotal
    user_id
    org_id
    gateway_charge
    address {
      address1
      address2
      address_type
      id
      landmark
      phone
      pincode
      receiver_first_name
      receiver_last_name
      user_id
      state {
        name
      }
    }
    cart_items(where: { is_deleted: { _eq: false } }) {
      cart_id
      id
      is_deleted
      product_id
      product_variation_id
      quantity
      type
      product {
        id
        has_variation
        name
        status
        item_code
        price
        price_per_gm
        product_media(where: { is_active: { _eq: true } }, order_by: { id: asc }) {
          media {
            bucket
            visibility
            cloud
            path
          }
        }
      }
      product_variation {
        id
        name
        product_id
        quantity
        sale_price
        sku
        status
        value
        product_media(where: { is_active: { _eq: true } }, order_by: { id: asc }) {
          media {
            bucket
            visibility
            cloud
            path
          }
        }
      }
      cart_item_sizes(where: { is_deleted: { _eq: false } }) {
        cart_item_id
        id
        metal
        quantity
        variant_size_id
        plating {
          id
          name
          price_per_gram
        }
        discount {
          id
          discount_percentage
          max_quantity
          min_quantity
        }
        product_variant_size {
          id
          product_id
          product_variation_id
          ring_inr_size
          ring_size
          stone_code
          quantity
          original_stock
          weight
        }
      }
    }
    cart_meta {
      currency_id
      id
      shipping_date
      payment_status
      first_order_discount
      remote_charges
      shipping_rate
      tracking_number
      shipping_status
      shipping_type
      total_weight
      tracking_url
      ship_status {
        id
        name
      }
      pay_status {
        id
        name
      }
      currency {
        conversion_rate
        name
        id
        symbol
      }
      extra_discount {
        code
        name
        max_discount_amount
        fixed_amount
        is_percentage
        value
        currency_choosen {
          id
          name
          conversion_rate
        }
      }
      coupon_applied {
        id
        name
        min_amount_to_apply
        max_discount_amount
        is_percentage
        value
        currency_choosen {
          id
          name
          conversion_rate
        }
      }
      payment_gateway {
        name
        id
      }
      shipping {
        id
        vendor
      }
    }
  }
}
`;

export const REMOVE_CART_ITEM = gql`
mutation removeCartItem($_set: order_cart_items_set_input = {}, $where: order_cart_items_bool_exp = {}) {
  update_order_cart_items(where: $where, _set: $_set) {
    returning {
      id
    }
  }
}
`

export const GET_TRANSALATION = gql`
query Tenant_translation {
    tenant_translation(
        where: { 
            created_at: { _gte: "2025-03-29T05:21:22.168013+00:00" },
            code: { _neq: "hi2" }
        }
    ) {
        code
        created_at
        data
        id
        __typename
    }
}


`
export const MASTER_LANGUAGE = gql`
query Master_language {
    master_language (
            where: { 
            created_at: { _gte: "2025-03-29T05:21:22.168013+00:00" },
            code: { _neq: "hi2" }
        }
    ) {
        code
        created_at
        id
        name
    }
}


`;

export const LOW_STOCK_PRODUCTS = gql`
query Product_low_stock_variant_sizes(
  $limit: Int
  $offset: Int
  $where: product_low_stock_variant_sizes_bool_exp
  $order_by: [product_low_stock_variant_sizes_order_by!]
) {
  product_low_stock_variant_sizes(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    available_stock
    id
    original_stock
    product_total_stock
    rack
    pro_code
    product_variation_id
    product_id
    stone_code
    ring_size
    ring_inr_size
    product {
      id
      name
      price
      price_per_gm
      product_code
      dim_weight
      dim_length
      dim_width
      status
      has_variation
      description
      min_order_quantity
      min_order_plating
      category { name }
      sub_category { name }
      product_media {
        media {
          cloud
          path
          visibility
          bucket
        }
      }
    }
    product_variation {
      name
      value
      product_variation_gems {       # ← ADD THIS
        gems_id
        gem {
          id
          name
        }
      }
      product_media {
        media {
          bucket
          cloud
          path
          visibility
        }
      }
    }
  }
  product_low_stock_variant_sizes_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
`;
export const MASTER_COUNTRIES = gql`

query Master_countries {
    master_countries(order_by: {name: asc}) {
        created_at
        deleted_at
        id
        name
        dial_code
        states(order_by: {name: asc}) {
            country_id
            deleted_at
            id
            is_active
            name
        }
    }
}

`;
// GraphQL Queries and Mutations
export const GET_PRODUCT_REVIEWS = gql`
  query GetProductReviews($product_id: uuid!) {
    product_product_review(
      where: { product_id: { _eq: $product_id }, is_deleted: { _eq: false } }
      order_by: { created_at: desc }
    ) {
      id
      rating
      description
      created_at
      first_name
      last_name
      user_id
    }
  }
`;

export const GET_ALL_REVIEWS = gql`


 query Product_product_review($where: product_product_review_bool_exp) {
    product_product_review(where: $where) {
        created_at
    
        description
        id
        is_deleted
        is_visible
        
        product_id
        rating
        updated_at
      
        user_id
    }
}





`;
export const GET_ALL_PLATING = gql`

query MasterPlating($where: master_plating_bool_exp) {
  master_plating(where: $where) {

    
    id
    name
    status

  }
}


`
export const GET_ALL_ADDRESS = gql`

query Org_users_by_pk($id: uuid!, $where: common_addresses_bool_exp) {
  org_users_by_pk(id: $id) {
    addresses(where: $where) {
      address1
      address2
      address_type
      country_id
      created_at
      deleted_at
      id
      city
      is_active
      is_primary
      landmark
      phone
      pincode
      receiver_first_name
      receiver_last_name
      state_id
      user_id
      __typename
    }
    __typename
  }
}



`



export const GET_ALL_COUPANS = gql`
query Tenant_org_coupons {
    tenant_org_coupons(
        where: { 
            status: { _eq: "ACTIVE" }, 

        }
    ) {
        code
        created_at
        end_date
        fixed_amount
        id
        is_percentage
        max_discount_amount
        min_amount_to_apply
        name
        start_date
        status
        terms
        value
        __typename
    }
}

`


export const GET_PRIMARY_ADDRESS = gql`
  query GetPrimaryAddress($id: uuid!) {
    common_addresses_by_pk(id: $id) {
      address1
      address2
      address_type
      id
      is_primary
      landmark
      phone
      pincode
      receiver_first_name
      receiver_last_name
      country {
        name
      }
      state {
        name
      }
    }
  }
`;
export const GET_USD = gql`

query Master_currency {
    master_currency(where: { name: { _ilike: "usd" } }) {
        conversion_rate
        name
    
    }
}

`


export const PENDING_PAYMENT_CART = gql`
query Order_carts($where: order_carts_bool_exp!) {
    order_carts(where: $where) {
        id
        org_id
        user_id
        address_id
        shipping_id
        order_number
        gateway_charge
        final_amount
        subtotal
        insurance_charge
        cart_meta {
            shipping_rate
            remote_charges
            currency {
                id
                name
                symbol
                conversion_rate
            }
            payment_gateway {
                name
            }
            coupon_applied {
                name
                fixed_amount
                is_percentage
                max_discount_amount
                min_amount_to_apply
                value
                currency_choosen {
                    name
                    symbol
                    conversion_rate
                }
            }
        }
        address {
            pincode
            country {
                name
            }
        }
    }
}



`
export const CHECK_COUNTRY  = gql`
query Common_addresses($id: uuid!) {
    common_addresses(where: { id: { _eq: $id } }) {
        country {
            name
        }
    }
}
`
export const GET_PLACED_ORDER = gql`
query Order_carts($cartId: uuid!) {
    order_carts(where: { id: { _eq: $cartId } }) {
        cart_meta {
            first_order_discount
            currency {
                conversion_rate
                id
                name
                symbol
                __typename
            }
            shipping_rate
            mail_sent
            remote_charges
            shipping_estimate
            payment_status
            __typename
            payment_gateway {
                name
                __typename
            }
            coupon_applied {
                id
                name
                min_amount_to_apply
                is_percentage
                value
                currency_choosen {
                    id
                    name
                    conversion_rate
                }
            }
            extra_discount {
                code
                name
                max_discount_amount
                fixed_amount
                value
            }
        }
        id
        order_number
        processed_at
        final_amount
        address_id
        gateway_charge
        plating_charge
        making_charge
        insurance_charge
        subtotal
        cart_items(where: { is_deleted: { _eq: false } }) {
            cart_id
            id
            is_deleted
            product_id
            product_variation_id
            quantity
            product {
                has_variation
                name
                product_media {
                    media {
                        bucket
                        cloud
                        path
                        visibility
                        __typename
                    }
                    __typename
                }
                dim_weight
                price_per_gm
                product_code
                __typename
                category {
                    name
                    id
                }
                sub_category {
                    name
                    id
                }
            }
            product_variation {
                id
                name
                __typename
            }
            cart_item_sizes(where: { is_deleted: { _eq: false } }) {
                cart_id
                cart_item_id
                id
                metal
                is_deleted
                quantity
                variant_size_id
                plating {
                    id
                    name
                    price_per_gram
                }
                product_variant_size {
                    id
                    quantity
                    ring_size
                    size_value
                    stone_code
                    weight
                    original_stock
                    __typename
                }
                __typename
                discount {
                    id
                    discount_percentage
                    max_quantity
                    min_quantity
                }
            }
            __typename
        }
        is_deleted
        __typename
    }
}


`;

export const GET_BEST_SELLERS = gql`
query Product_best_selling($where: product_best_selling_bool_exp = {  }) {
    product_best_selling(where: $where) {
        deleted_at
        deleted_by_id
        id
        product_id
        product {
            available_quantity
            dim_height
            dim_length
            dim_weight
            dim_width
            has_variation
            id
            name
            price_per_gm
            price
            status
            product_media {
                media {
                    bucket
                    path
                }
            }
            product_variations {
                actual_price
                id
                name
                product_id
                quantity
                sale_price
                value
                product_media {
                    media {
                        bucket
                        path
                    }
                }
                product_variant_sizes {
                    height
                    id
                    length
                    product_id
                    product_variation_id
                    quantity
                    rack
                    ring_inr_size
                    ring_size
                    size_value
                    stone_code
                    weight
                    width
                }
                product_variation_gems {
                    gem {
                        name
                        id
                    }
                }
            }
            category {
                id
                name
                status
            }
            sub_category {
                id
                name
            }
        }
    }
}


`

export const GET_CATEGORIES_AND_SUBCATEGORIES = gql`
query GET_CATEGORIES_AND_SUBCATEGORIES {
    product_categories(
        where: {
            is_active: { _eq: true }
 
            deleted_at: { _is_null: true }
        }
    ) {
        id
        is_active
        menu_visible
        deleted_at
        deleted_by_id
        name
        file {
            bucket
            visibility
            cloud
            path
        }
        sub_categories {
            id
            name
            category_id
            deleted_at
            deleted_by_id
            file {
                bucket
                visibility
                cloud
                path
            }
        }
    }
}

`;

export const GET_CATEGORY_NAMES = gql`
query GET_CATEGORIES_AND_SUBCATEGORIES {
    product_categories(
        where: {
            is_active: { _eq: true }
 
            deleted_at: { _is_null: true }
        }
    ) {
        id
   
  
        name
  
        sub_categories {
            id
            name
            category_id
         
     
        }
    }
}

`;
export const GET_CATEGORIES_AND_SUBCATEGORIES_ALL = gql`
query GET_CATEGORIES_AND_SUBCATEGORIES {
    product_categories(
        where: {
            is_active: { _eq: true }
   
            deleted_at: { _is_null: true }
        }
    ) {
        id
        is_active
        menu_visible
        deleted_at
        deleted_by_id
        name
        file {
            bucket
            visibility
            cloud
            path
        }
        sub_categories {
            id
            name
            category_id
            deleted_at
            deleted_by_id
          fileByImageId{
                bucket
                visibility
                cloud
                path
            }
        }
    }
}

`;
export const GET_NAV_CATEGORIES_AND_SUBCATEGORIES = gql`

query Tenant_navigation_groups {
    tenant_navigation_groups {
        id
        label
        slug
        sort_order
        navigation_group_categories {
            sort_order
            category_id
            category {
                id
                name
                file {
                    bucket
                    visibility
                    cloud
                    path
                }
                sub_categories {
                    id
                    name
                    fileByImageId {
                        bucket
                        visibility
                        cloud
                        path
                    }
                }
            }
        }
    }
}

`
export const GET_HOME_CATEGORIES = gql`
query GET_CATEGORIES {
    product_categories(
        where: {
            is_active: { _eq: true }
            deleted_at: { _is_null: true }
            icon_id: { _is_null: false }
        }
    ) {
        id
        is_active
        deleted_at
        deleted_by_id
        name
        icon {
            bucket
            visibility
            cloud
            path
        }
    }
}


`;
export const GET_SUBCATEGORIES_BY_CATEGORY_NAME = gql`
query ProductSubCategories($term: String!) {
  product_sub_categories(
    where: { category: { name: { _ilike: $term } } }
    order_by: { updated_at: desc }
  ) {
    name
    category_id
    id
    fileByImageId {
      bucket
      cloud
      path
      visibility
    }
    products_aggregate {
      aggregate {
        count
      }
    }
  }
}
`;

// Variation count per sub-category for the category page — one count-only
// aggregate per sub-category, sent as ONE request with aliases (v0, v1, …).
// Replaces downloading every product row of every sub-category just to sum
// their variation counts (all-silver: 9.5s / 625 KB → ~0.4s / 3 KB, same numbers).
export const buildSubcategoryVariationCountsQuery = (subCategoryIds) => {
  const fields = subCategoryIds
    .map(
      (_, i) =>
        `v${i}: product_product_variations_aggregate(where: { product: { sub_category_id: { _eq: $id${i} } } }) { aggregate { count } }`
    )
    .join("\n    ");
  const vars = subCategoryIds.map((_, i) => `$id${i}: uuid!`).join(", ");
  return gql(`query SubcategoryVariationCounts(${vars}) {\n    ${fields}\n  }`);
};
export const _MASTER_CATEGORY = gql`
query GET_CATEGORIES {
    product_categories(
        where: {
            is_active: { _eq: true }
 
            deleted_at: { _is_null: true }
        }
    ) {
        id
   
  
        name
  
       
    }
}


`

export const MASTER_CURRENCY = gql`
query Master_currency {
    master_currency {
        conversion_rate
        symbol
        name
        id
       
    }
}

`

export const GET_PAYMENT_GATEWAYS = gql`
query Order_payment_gateways {
    order_payment_gateways {
        id
        is_online
        name
        status
    }
}


`

export const GET_SHIPPING_METHODS = gql`
query Shipping_config {
    shipping_config {
     
        id
        is_active
    
     
        vendor
    }
}


`
export const ALL_GEMS = gql`


query Master_gems {
    master_gems {
        description
        id
        image_id
        name
        zodiac_sign
  
        file {
            bucket
            cloud
  
   
            path
            
            visibility
        }
    }
}






`
export const SOME_GEMS = gql`
  query GemsForProducts($where: product_products_bool_exp!) {
    master_gems(
      where: { product_variation_gems: { product_variation: { product: $where } } }
      order_by: { name: asc }
    ) {
      id
      name
    }
  }
`;


export const CHECK_ORDERS = gql`
query Tenant_mail_list($where: tenant_mail_list_bool_exp) {
  tenant_mail_list(where: $where) {
    first_order_placed
    mail
  }
}
`
export const SEARCH_GEMSTONE = gql`
  query Master_gems($where: master_gems_bool_exp) {
    master_gems(where: $where) {
      id
      name
    }
  }
`;
export const ORDER_CART_META = gql`
  query OrderCartMeta($where: order_cart_meta_bool_exp) {
    order_cart_meta(where: $where) {
      id
      cart_id
    }
  }
`;

export const GET_ALL_SIZES = gql`
query Master_sizes {
    master_sizes(where: { deleted_by_id: { _is_null: true } }) {
        currency_id
        deleted_by_id
        id
        value
    }
}


`
export const GET_DETAILED_PRODUCT = gql`

query Product_products(
    $where: product_products_bool_exp
    $order_by: [product_products_order_by!]
    $limit: Int
) {
    product_products(where: $where, order_by: $order_by, limit: $limit) {
        category_id
        description
        id
        has_variation
        name
        dim_length
        dim_width
        status
        min_order_plating
        min_order_quantity
        category {
            name
            __typename
        }
        product_media {
            media {
                bucket
                cloud
                id
                type
                visibility
                path
                __typename
            }
            __typename
        }
        product_variations {
            actual_price
            id
            is_stock_available
            name
            value
            product_id
            quantity
            sale_price
            sku
            __typename
            product_media {
                media {
                    bucket
                    cloud
                    visibility
                    path
                    __typename
                }
                __typename
            }
            product_variation_gems {
                gem {
                    id
                    name
                    __typename
                }
                gems_id
                __typename
            }
            product_variant_sizes {
                id
                product_id
                product_variation_id
                quantity
                ring_size
                stone_code
                weight
            }
        }
        __typename
        sub_category {
            id
            has_size
            name
        }
        price_per_gm
    }
}

`

export const GET_BIRTHSTONE = gql`
query MasterBirthstones($where: master_birthstones_bool_exp) {
  master_birthstones(where: $where, limit: 1) {
    metal
    month
    name
    origin
    healing
    position
  }
}

`
export const GET_BIRTHSTONE_NAME = gql`
query name {
    master_birthstones {

        name

    }
}

`

export const GET_COUPONS = gql`
  query GetCoupons {
    tenant_org_coupons {
      id
      name
      code
      start_date
      end_date
      is_percentage
      min_amount_to_apply
      value
      fixed_amount
      max_discount_amount
      auto_apply
      currency_choosen {
        id
        name
        conversion_rate
      }
    }
  }
`;
export const GET_PRODUCT_DISCOUNTS = gql`

query Tenant_product_discounts($where: tenant_product_discounts_bool_exp!) {
  tenant_product_discounts(where: $where) {
    max_quantity
    min_quantity
    discount_percentage
    sub_category_id
    category_id
  }
}

`
export const GET_NEW_ARRIVALS = gql`
  query Product_new_arrivals(
    $limit: Int
    $offset: Int
    $where: product_new_arrivals_bool_exp
  ) {
    product_new_arrivals(
      limit: $limit
      offset: $offset
      where: $where
      distinct_on: [product_id, product_variation_id]
      order_by: [
        { product_id: asc }
        { product_variation_id: asc }
      ]
    ) {
      product {
        id
        item_code
        name
        price
        price_per_gm
        dim_weight
        category {
          name
          id
        }
        sub_category {
          id
          name
        }
        product_media {
          media {
            bucket
            path
            visibility
            cloud
          }
        }

        # Variant count
        variations_count: product_variations_aggregate {
          aggregate {
            count
          }
        }

        # All variations with stock aggregate — no limit, no nodes needed
        product_variations {
          product_variant_sizes_aggregate {
            aggregate {
              sum {
                quantity
              }
            }
          }
        }
      }
      product_variations {
        id
        name
        value
        product_variation_gems {
          gem {
            id
            name
          }
        }
        product_media {
          media {
            bucket
            path
            visibility
            cloud
          }
        }
      }
      product_variant_sizes {
        quantity
        ring_inr_size
        ring_size
        size_value
        stone_code
      }
    }

    product_new_arrivals_aggregate(where: $where) {
      aggregate {
        count(columns: [product_id, product_variation_id], distinct: true)
      }
    }
  }
`;

export const GET_PRICE_BOUNDS = gql`
  query GetPriceBounds($where: product_products_bool_exp!) {
    product_products_aggregate(where: $where) {
      aggregate {
        min {
          price
        }
        max {
          price
        }
        count
      }
    }
  }
`;

export const GET_PRODUCTS_STOCK_BY_ITEM_CODES = gql`
  query GetProductsStockByItemCodes($itemCodes: [String!]!) {
    product_products(where: { item_code: { _in: $itemCodes } }) {
      item_code
      product_variations {
        product_variant_sizes {
          quantity
        }
      }
    }
  }
`;

export const GET_GIFS = gql`

query Media_files {
    media_files(where: { type: { _eq: "Video" } }) {
        type
        visibility
        path
        cloud
        bucket
    }
}


`
export const GET_INSTA = gql`
  query GetInstagramPosts($where: tenant_org_web_configuration_bool_exp) {
    tenant_org_web_configuration(where: $where) {
      web_configuration_meta(
        where: {
          type: { _eq: "INSTAGRAM" }
          is_deleted: { _eq: false }
        }
        order_by: { priority: asc }
      ) {
        file {
          bucket
          cloud
          path
          visibility
        }
        priority
        redirection_url
        type
      }
    }
  }
`;

export const GET_BANNERS = gql`
query Tenant_org_web_configuration(
  $where: tenant_org_web_configuration_bool_exp
) {
  tenant_org_web_configuration(where: $where) {
    type
    web_configuration_meta(
      where: { 
        type: { _eq: "BANNER" }, 
        is_deleted: { _eq: false }  
      }
      order_by: { priority: asc }   
    ) {
      file {
        bucket
        cloud
        path
        visibility
      }
                          mobile_file {
          bucket
          cloud
          path
          visibility
        }
      priority
      redirection_url
      type
    }
  }
}

`
export const GET_EXOLORE_COLLECTIONS = gql`
query Tenant_org_web_configuration(
  $where: tenant_org_web_configuration_bool_exp
) {
  tenant_org_web_configuration(where: $where) {
    type
    web_configuration_meta(
      where: { 
        type: { _eq: "EXPLORE_COLLECTION" }, 
        is_deleted: { _eq: false }  
      }
      order_by: { priority: asc }   
    ) {
      file {
        bucket
        cloud
        path
        visibility
      }
title
      priority
      redirection_url
      type
    }
  }
}

`
export const GET_POPUP = gql`
query Tenant_org_web_configuration(
  $where: tenant_org_web_configuration_bool_exp
) {
  tenant_org_web_configuration(where: $where) {
    type
    web_configuration_meta(
      where: { 
        type: { _eq: "POPUP" }, 
        is_deleted: { _eq: false }  
      }
      order_by: { priority: asc }   
    ) {
      file {
        bucket
        cloud
        path
        visibility
      }
title
      description
    }
  }
}

`
export const GET_VOLUME_PRICING = gql`
query Tenant_org_web_configuration(
  $where: tenant_org_web_configuration_bool_exp
) {
  tenant_org_web_configuration(where: $where) {
    type
    web_configuration_meta(
      where: { 
        type: { _eq: "VOLUME_PRICING" }, 
        is_deleted: { _eq: false }  
      }
      order_by: { priority: asc }   
    ) {
data_values
title
      priority
      redirection_url
      type
    }
  }
}

`
export const GET_BIRTHSTONE_CONFIG = gql`
query Tenant_org_web_configuration(
  $where: tenant_org_web_configuration_bool_exp
) {
  tenant_org_web_configuration(where: $where) {
    type
    web_configuration_meta(
      where: { 
        type: { _eq: "BIRTHSTONE_MONTH" }, 
        is_deleted: { _eq: false }  
      }
      order_by: { priority: asc }   
    ) {
data_values
title
description
      priority
      redirection_url
      type
            file {
        bucket
        cloud
        path
        visibility
      }
    }
  }
}

`

export const GET_THREE_CARD = gql`
query Tenant_org_web_configuration(
  $where: tenant_org_web_configuration_bool_exp
) {
  tenant_org_web_configuration(where: $where) {
    type
    web_configuration_meta(
      where: { 
        type: { _eq: "THREE_CARDS" }, 
        is_deleted: { _eq: false }  
      }
      order_by: { priority: asc }   
    ) {
      file {
        bucket
        cloud
        path
        visibility
      }
title
      priority
      redirection_url
      type
    }
  }
}

`
export const GET_HANDCRAFTED_BANNER = gql`
query Tenant_org_web_configuration(
  $where: tenant_org_web_configuration_bool_exp
) {
  tenant_org_web_configuration(where: $where) {
    type
    web_configuration_meta(
      where: { 
        type: { _eq: "HANDCRAFTED_BANNER" }, 
        is_deleted: { _eq: false }  
      }
      order_by: { priority: asc }   
    ) {
      file {
        bucket
        cloud
        path
        visibility
      }
        mobile_file{

               bucket
        cloud
        path
        visibility
        }
title
      priority
      redirection_url
      type
    }
  }
}

`
export const GET_DESIGN_LED = gql`
query Tenant_org_web_configuration(
  $where: tenant_org_web_configuration_bool_exp
) {
  tenant_org_web_configuration(where: $where) {
    type
    web_configuration_meta(
      where: { 
        type: { _eq: "DESIGN_LED" }, 
        is_deleted: { _eq: false }  
      }
      order_by: { priority: asc }   
    ) {
      file {
        bucket
        cloud
        path
        visibility
      }
        icon{

               bucket
        cloud
        path
        visibility
        }
title
      priority
      redirection_url
      type
    }
  }
}

`
export const GET_CMS_REVIEWS = gql`
query Tenant_org_web_configuration(
  $where: tenant_org_web_configuration_bool_exp
) {
  tenant_org_web_configuration(where: $where) {
    type
    web_configuration_meta(
      where: { 
        type: { _eq: "REVIEW" }, 
        is_deleted: { _eq: false }  
      }
      order_by: { priority: asc }   
    ) {

title
      priority
      redirection_url
      type
      data_values
    }
  }
}

`
export const GET_VIDEOS = gql`
query Tenant_org_web_configuration(
  $where: tenant_org_web_configuration_bool_exp
) {
  tenant_org_web_configuration(where: $where) {
    type
    web_configuration_meta(
      where: { 
        type: { _eq: "VIDEO" }, 
        is_deleted: { _eq: false }  
      }
      order_by: { priority: asc }   
    ) {
      file {
        bucket
        cloud
        path
        visibility
      }
      priority
      redirection_url
      type
    }
  }
}

`

export const GET_PINCODES = gql`
query CommonRemotePincodes(
  $where: common_remote_pincodes_bool_exp!
) {
  common_remote_pincodes(where: $where) {
    id
    pin_code
    fee
    currency {
      id
      conversion_rate
      name
    }
  }

}
`

export const CHECK_MAIL_IN_LIST = gql`
query TenantMailList($where: tenant_mail_list_bool_exp) {
  tenant_mail_list(where: $where) {
    first_order_placed
    mail
  }
}
`
export const GET_ALL_PRODUCTS = gql`


query Product_products(
    $where: product_products_bool_exp
    $order_by: [product_products_order_by!]
    $limit: Int
    $offset: Int
) {
    product_products(
        where: $where
        order_by: $order_by
        limit: $limit
        offset: $offset
    ) {
        price_per_gm
        price
        category_id
        description
        is_handcrafted
        available_quantity
        product_code
        item_code
        item_code_num
        dim_weight
        id
        has_variation
        name
        dim_length
        dim_width
        dimensions
        making_charges
        packaging_charges
        min_order_plating
        min_order_quantity
        category {
            name
            id
            __typename
        }
        product_media {
            media {
                file_name
                path
                __typename
            }
            __typename
        }
        product_variations {
            actual_price
            id
            is_stock_available
            name
            value
            product_id
            metal
            dimensions
            sale_price
      
            __typename
            product_variant_sizes {
                id
                product_id
                product_variation_id
                quantity
                original_stock
                ring_size
                ring_inr_size
                pro_code
                size_value
                stone_code
                display_plating
                weight
                __typename
            }
            product_media {
                media {
                    id
                    file_name
                    path
                    __typename
                }
                __typename
            }
            product_variation_gems {
                gem {
                    id
                    name
                    __typename
                }
                gems_id
                __typename
            }
        }
        __typename
        sub_category {
            id
            has_size
            name
            __typename
        }
    }
    master_plating(
        where: {
            deleted_by_id: { _is_null: true }
            deleted_at: { _is_null: true }
            status: { _eq: "Active" }
        }
    ) {
        id
        name
        price_per_gram
        status
    }
product_products_aggregate(where: $where){
        aggregate {
            count(columns: [id])
        }
    }
}




`;
export const SEARCH_BY_CODE = gql`
query SearchByCode($where: product_products_bool_exp = {}) {
  product_products(
    where: $where
    limit: 8
    order_by: { name: asc }
  ) {
    id
    name
    product_code
    item_code
    new_item_code
    product_media(limit: 1) {
      media {
        path
      }
    }
    product_variant_sizes(limit: 10) {
      pro_code
      new_pro_code
    }
  }
}
`;

// Header suggestions for multi-word searches ("peridot bracelets"): every word
// must match name / category / sub-category / gem — the same rule the /shop
// page uses on Enter, so suggestions and results agree. $where is built in
// Header.tsx; gems are fetched by any word and ranked on the client.
export const HEADER_SEARCH_WORDS = gql`
  query HeaderSearchWords(
    $where: product_products_bool_exp!
    $gemWhere: master_gems_bool_exp!
    $limit: Int!
    $gemLimit: Int!
  ) {
    product_products(where: $where, limit: $limit, order_by: { item_code_num: desc_nulls_last }) {
      ...HeaderSearchWordsProduct
    }
    master_gems(where: $gemWhere, limit: $gemLimit, order_by: { name: asc }) {
      id
      name
    }
  }

  fragment HeaderSearchWordsProduct on product_products {
    id
    name
    item_code
    new_item_code
    product_code
    category {
      id
      name
    }
    sub_category {
      id
      name
    }
    product_media(limit: 1) {
      media {
        path
      }
    }
  }
`;

// Header search suggestions. One request, one small indexed lookup per match
// type (aliases) instead of a single 7-way _or across relationships — that
// _or took ~800-1100ms on prod, this takes ~250ms. Results are merged in the
// order listed (name matches first) and de-duplicated on the client.
export const HEADER_SEARCH = gql`
  query HeaderSearch($name: String!, $code: String!, $limit: Int!, $gemLimit: Int!) {
    by_name: product_products(
      where: { name: { _ilike: $name } }
      limit: $limit
      order_by: { name: asc }
    ) { ...HeaderSearchProduct }
    by_item_code: product_products(
      where: { _or: [{ item_code: { _ilike: $code } }, { new_item_code: { _ilike: $code } }] }
      limit: $limit
      order_by: { name: asc }
    ) { ...HeaderSearchProduct }
    by_pro_code: product_products(
      where: { product_variant_sizes: { _or: [{ pro_code: { _ilike: $code } }, { new_pro_code: { _ilike: $code } }] } }
      limit: $limit
      order_by: { name: asc }
    ) { ...HeaderSearchProduct }
    by_variation: product_products(
      where: { product_variations: { value: { _ilike: $name } } }
      limit: $limit
      order_by: { name: asc }
    ) { ...HeaderSearchProduct }
    by_gem: product_products(
      where: { product_variations: { product_variation_gems: { gem: { name: { _ilike: $name } } } } }
      limit: $limit
      order_by: { name: asc }
    ) { ...HeaderSearchProduct }
    master_gems(where: { name: { _ilike: $name } }, limit: $gemLimit, order_by: { name: asc }) {
      id
      name
    }
  }

  fragment HeaderSearchProduct on product_products {
    id
    name
    item_code
    new_item_code
    product_code
    category {
      id
      name
    }
    sub_category {
      id
      name
    }
    product_media(limit: 1) {
      media {
        path
      }
    }
  }
`;

export const SEARCH_BY_NAME = gql`
  query SearchByName($where: product_products_bool_exp) {
    product_products(where: $where, limit: 8, order_by: { name: asc }) {
      id
      name
      product_code
    category {
          name
          id
        }
        sub_category {
          id
          name
        }
      product_media { media { path } }
    }
  }
`;
export const SEARCH_PRODUCTS_SUGGESTIONS = gql`
  query SearchProductSuggestions(
    $nameWhere: product_products_bool_exp, 
    $codeWhere: product_products_bool_exp
  ) {
    byName: product_products(
      where: $nameWhere, 
      limit: 8, 
      order_by: { name: asc }
    ) {
      id
      name
      product_code
      item_code
      product_media { media { path } }
    }
    byCode: product_products(
      where: $codeWhere, 
      limit: 8, 
      order_by: { name: asc }
    ) {
      id
      name
      product_code
      item_code
      product_media { media { path } }
    }
  }
`;
export const SEARCH_VARIANT_SUGGESTIONS = gql`
  query SearchVariantSuggestions($stoneCode: String!) {
    product_variant_sizes: product_product_variant_sizes(
      where: { stone_code: { _ilike: $stoneCode } }
      limit: 8
    ) {
      id
      stone_code
      product_variation {
        product {
          id
          name
          product_code
          product_media { media { path } }
        }
      }
    }
  }
`;

export const GET_BLOGS = gql`
query TenantBlogs($where: tenant_blogs_bool_exp!) {
  tenant_blogs(where: $where) {
   
    created_at
    deleted_at
    deleted_by_id
    description
    id
    is_published
    org_id
    thumbnail_media_id
    title
    file {
      cloud
      bucket
      path
      type
      visibility
    }
  }
}
`

export const GET_ONE_BLOG = gql`
query TenantBlogs($where: tenant_blogs_bool_exp!) {
  tenant_blogs(where: $where) {
   content
    created_at
    deleted_at
    deleted_by_id
    description
    id
    is_published
    org_id
    thumbnail_media_id
    title
    file {
      cloud
      bucket
      path
      type
      visibility
    }
  }
}
`
export const GET_VARIANT_SIZES_STOCK = gql`
  query GetVariantSizesStock($ids: [uuid!]!) {
    product_variant_sizes(where: { id: { _in: $ids } }) {
      id
      quantity
    }
  }
`;
// Admin hand-picked New Arrivals (product.curated_new_arrivals).
// Shaped like one GET_NEW_ARRIVALS row so the page can reuse the same card mapping:
// product + its first variation + that variation's first size.
export const GET_CURATED_NEW_ARRIVALS = gql`
  query GetCuratedNewArrivals {
    product_curated_new_arrivals(
      where: {
        deleted_at: { _is_null: true }
        product: { status: { _eq: "ACTIVE" } }
      }
      order_by: { created_at: desc }
    ) {
      id
      product {
        id
        item_code
        name
        price
        price_per_gm
        dim_weight
        category {
          name
          id
        }
        sub_category {
          id
          name
        }
        product_media(where: { is_active: { _eq: true } }) {
          media {
            bucket
            path
            visibility
            cloud
          }
        }
        variations_count: product_variations_aggregate {
          aggregate {
            count
          }
        }
        # Stock across every variation, used to hide sold-out picks
        stock: product_variations {
          product_variant_sizes_aggregate {
            aggregate {
              sum {
                quantity
              }
            }
          }
        }
        # First variation = what the card shows (image, gems, sizes)
        first_variation: product_variations(limit: 1, order_by: { id: asc }) {
          id
          name
          value
          product_variation_gems {
            gem {
              id
              name
            }
          }
          product_media(where: { is_active: { _eq: true } }) {
            media {
              bucket
              path
              visibility
              cloud
            }
          }
          product_variant_sizes(limit: 1) {
            quantity
            ring_inr_size
            ring_size
            size_value
            stone_code
          }
        }
      }
    }
  }
`;

// Shop search: turn the typed words into category / sub-category / gem ids
// (small tables, ~50ms) so the product filter can use plain id lookups instead
// of regex-matching those names through joins for every product — that took
// up to 20s+ for 3-word searches ("amethyst silver ring"); now ~0.5s.
// Each where is an _or of the words' _iregex patterns; the page then maps the
// returned names back to each word on the client.
export const RESOLVE_SEARCH_WORD_IDS = gql`
  query ResolveSearchWordIds(
    $categoryWhere: product_categories_bool_exp!
    $subCategoryWhere: product_sub_categories_bool_exp!
    $gemWhere: master_gems_bool_exp!
  ) {
    product_categories(where: $categoryWhere) {
      id
      name
    }
    product_sub_categories(where: $subCategoryWhere) {
      id
      name
    }
    master_gems(where: $gemWhere) {
      id
      name
    }
  }
`;

// Lean listing query for the shop / search page.
// GET_ALL_PRODUCTS returns every size row of every variation plus master_plating
// (~10 KB per product); the grid only needs what ProductCard renders:
// thumbnails per variation, gem ids for the gemstone filter, one pro_code for the
// badge and a stock SUM (aggregate) instead of every size row.
export const GET_SHOP_PRODUCTS = gql`
  query ShopProducts(
    $where: product_products_bool_exp
    $order_by: [product_products_order_by!]
    $limit: Int
    $offset: Int
  ) {
    product_products(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      name
      price
      price_per_gm
      item_code
      product_code
      has_variation
      status
      dim_weight
      dim_length
      dim_width
      min_order_quantity
      min_order_plating
      category {
        id
        name
      }
      sub_category {
        id
        name
        has_size
      }
      product_media(limit: 1) {
        media {
          path
        }
      }
      variations_total: product_variations_aggregate {
        aggregate {
          count
        }
      }
      # ONE stock sum per product (same total as summing every variation —
      # verified on prod) instead of one aggregate per variation, which was the
      # slowest part of this query on search pages with many-variation products.
      stock_total: product_variant_sizes_aggregate {
        aggregate {
          sum {
            quantity
          }
        }
      }
      product_variations {
        id
        value
        sale_price
        product_media(limit: 1) {
          media {
            path
          }
        }
        product_variation_gems {
          gems_id
          gem {
            id
            name
          }
        }
        # first size row: pro_code for the card badge/link + a stock hint for the
        # search variation tie-break (no where/order — those made it ~2x slower)
        product_variant_sizes(limit: 1) {
          pro_code
          quantity
        }
      }
    }
    product_products_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

// Gateway charge master (order.payment_gateway_charges) — used by checkout,
// payment-pending and the create-payment-link route (same rules everywhere).
export const GET_GATEWAY_CHARGES = gql`
  query GatewayCharges {
    order_payment_gateway_charges(where: { is_active: { _eq: true } }) {
      id
      gateway_id
      currency_scope
      charge_type
      value
      min_order_inr
      max_order_inr
      is_active
      payment_gateway {
        id
        name
      }
      currency {
        id
        name
        symbol
        conversion_rate
      }
    }
  }
`;

// Shipping charge master (master.shipping_charges) — options shown at checkout.
export const GET_SHIPPING_CHARGES = gql`
  query ShippingCharges {
    master_shipping_charges(
      where: { is_active: { _eq: true } }
      order_by: [{ zone: asc }, { sort_order: asc }]
    ) {
      id
      zone
      code
      label
      delivery_text
      description
      icon
      slabs
      extra_step_grams
      extra_step_charge
      max_weight_grams
      free_above_amount
      hide_when_free
      sort_order
      is_active
      currency {
        id
        name
        symbol
        conversion_rate
      }
    }
  }
`;

// Is Cash on Delivery available for a pincode? (common.cod_pincodes, admin-uploaded list)
export const CHECK_COD_PINCODE = gql`
  query CheckCodPincode($pin: Int!) {
    common_cod_pincodes(where: { pin_code: { _eq: $pin }, is_active: { _eq: true } }, limit: 1) {
      id
      pin_code
    }
  }
`;
